(function () {

  var released = false;

  function releaseAll() {
    if (released) return;
    released = true;

    // 1. Restore real document.createElement
    if (window.__storeCreate) {
      document.createElement = window.__storeCreate;
    }

    // 2. Disconnect MutationObserver
    if (window.__storeObserver) {
      window.__storeObserver.disconnect();
    }

    // 3. Release all held external scripts
    var held = window.__storeHeld || [];
    held.forEach(function (item) {
      var fresh = window.__storeCreate('script');
      Array.from(item.el.attributes).forEach(function (attr) {
        fresh.setAttribute(attr.name, attr.value);
      });
      fresh.async = true;
      fresh.src = item.src;
      document.head.appendChild(fresh);
    });

    // 4. Release type="inert" scripts (hardcoded tags + inline pixel code)
    document.querySelectorAll('script[type="inert"]').forEach(function (old) {
      var src = old.getAttribute('data-lazy');
      var fresh = window.__storeCreate('script');

      Array.from(old.attributes).forEach(function (attr) {
        if (attr.name !== 'type' && attr.name !== 'data-lazy') {
          fresh.setAttribute(attr.name, attr.value);
        }
      });

      fresh.type = 'text/javascript';

      if (src) {
        // External script with src
        fresh.async = true;
        fresh.src = src;
      } else if (old.innerHTML.trim()) {
        // Inline script (e.g. hardcoded pixel code)
        fresh.innerHTML = old.innerHTML;
      }

      old.remove();
      document.head.appendChild(fresh);
    });

    // 5. Release lazy iframes
    document.querySelectorAll('iframe[data-lazy]').forEach(function (f) {
      f.src = f.getAttribute('data-lazy');
      f.removeAttribute('data-lazy');
    });

    // 6. Fire release event for rewired asyncLoad scripts
    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));

    console.log('[Store] Scripts released. Count: ' + (window.__storeHeld || []).length);
  }

  // Trigger on first user interaction
  var events = [
    'mousedown', 'mousemove', 'keydown',
    'scroll', 'touchstart', 'click', 'touchmove'
  ];

  function onInteraction() {
    events.forEach(function (e) {
      window.removeEventListener(e, onInteraction, false);
    });
    releaseAll();
  }

  events.forEach(function (e) {
    window.addEventListener(e, onInteraction, false);
  });

  // Fallback — release 8 seconds after page load
  window.addEventListener('load', function () {
    setTimeout(releaseAll, 9000);
  });

})();
